import { PassedInitialConfig } from 'angular-auth-oidc-client';

import { Url } from '@core/enums/url.enum';
import { environment } from '@env/environment';

export const AUTH_CONFIG: PassedInitialConfig = {
  config: {
    authority: environment.authentication.issuer,
    clientId: environment.authentication.clientId,
    forbiddenRoute: '/not-authorized',
    postLogoutRedirectUri: environment.authentication.postLogoutRedirectUri,
    redirectUrl: environment.authentication.redirectUrl,
    responseType: 'code',
    scope: environment.authentication.scope,
    historyCleanupOff: false,
    unauthorizedRoute: Url.Login,
    // Set to true to trigger an event when authorization result is received.
    triggerAuthorizationResultEvent: true,
    // **************** Refresh Token Properties *******************************
    useRefreshToken: true, // Enable refresh token support.
    // Automatically renew tokens using a silent renew (background token refresh).
    silentRenew: true,
    // The interval (in seconds) to refresh the access token using a refresh token.
    tokenRefreshInSeconds: 30,
    // The time (in seconds) before the token expires to initiate a silent renew.
    renewTimeBeforeTokenExpiresInSeconds:
      environment.authentication.renewTimeBeforeTokenExpiresValue, // This property silently initiates the request for a refresh token, aligning it with the ID TOKEN's expiration timeframe.
    // The maximum time (in seconds) to wait for a response during silent renew.
    silentRenewTimeoutInSeconds: 30,
    secureRoutes: Object.values(environment.graphql).map(({ url }) => url),
  },
};
